import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { IDarkTheme } from "styles/darkTheme";

const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    featureTitle: {
      fontWeight: theme.fontWeight.big,
      fontSize: "32px",
      color: theme.colors.neutrals.neturals_100,
      lineHeight: "56px",
      "@media (max-width: 899px)": {
        fontWeight: theme.fontWeight.bold,
        color: "#4F48F0"
      }
    },
    featuresSectionDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.heading_5,
      lineHeight: theme.fontSize.heading_5,
      color: theme.colors.neutrals.neutrals_70
    },
    featureDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.heading_9,
      color: theme.colors.neutrals.neutrals_90
    },
    postCardText: {
      fontSize: "15px",
      lineHeight: "24px",
      fontFamily: theme.fontFamily.montserrat,
      color: theme.colors.neutrals.neturals_100,
      fontWeight: theme.fontWeight.medium
    },
    saveYour: {
      fontFamily: theme.fontFamily.montserrat,
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.fontSize.heading_1,
      color: theme.colors.neutrals.neturals_100
    },
    moneyNow: {
      fontFamily: theme.fontFamily.montserrat,
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.fontSize.heading_1,
      color: theme.colors.secondary.secondary_50
    },
    lightBtn: {
      color: theme.colors.semantic.semantic_white,
      backgroundColor: theme.colors.secondary.secondary_50,
      textTransform: "none",
      padding: "16px 55px",
      borderRadius: "8px",
      marginTop: "auto",
      alignSelf: "center",
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.fontSize.bodyText_1,
      "&:hover": {
        backgroundColor: theme.colors.secondary.secondary_50
      }
    },
    darkBtn: {
      color: theme.colors.secondary.secondary_50,
      backgroundColor: theme.colors.semantic.semantic_white,
      textTransform: "none",
      padding: "20px 55px",
      borderRadius: "8px",
      marginTop: "auto",
      alignSelf: "center",
      "&:hover": {
        backgroundColor: theme.colors.semantic.semantic_white
      }
    },
    plansContainer: {
      justifyContent: "center",
      alignItems: "center",
      gap: "96px",
      "@media (max-width: 870px)": {
        marginTop: "1rem",
        overflow: "auto"
      }
    },
    plansSectionContainer: {
      display: "flex",
      flexDirection: "column",
      marginTop: "4.063rem",
      scrollMarginTop: "70px",
      justifyContent: "center",
      alignItems: "center",
      "@media (max-width: 870px)": {
        marginTop: "1rem",
        overflow: "auto"
      }
    }
  })
);

export default styles;
